/**
 * epgTimeIndicatorWrapper.tsx
 */
import ScreenUtils from '@screen';
import styled from 'styled-components';

const EpgTimeIndicatorWrapper = styled.div.attrs<{ indicator: number }>(
  (props) => ({
    style: {
      left: `calc(${props.indicator}% + ${4 * ScreenUtils.widthRatio}px)`,
    },
  })
)<{ indicator: number }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  top: -${12 * ScreenUtils.widthRatio}px;
  z-index: 10;
`;

export default EpgTimeIndicatorWrapper;
